import { render } from "./BatchAccountClosure.vue?vue&type=template&id=36ad8b8a&scoped=true"
import script from "./BatchAccountClosure.vue?vue&type=script&lang=js"
export * from "./BatchAccountClosure.vue?vue&type=script&lang=js"

import "./BatchAccountClosure.vue?vue&type=style&index=0&id=36ad8b8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36ad8b8a"

export default script